import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ButtonBase } from '@americanexpress/dls-react';
import { IconChevronDown } from '@americanexpress/dls-icons';
import styles from './DropdownButton.scss';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';

const DropdownButton = React.forwardRef(
  (
    {
      id, element, label, currentValue, travelers, onClick, isPopupOpened,
    },
    ref
  ) => {
    const isVariant = useIsHomePageVariantHook();
    return (
      <>
        {label && (
        <div className="flex flex-align-center">
          <span
            id={`${id}-label`}
            className={clsx(styles.dropdownLabel, 'body font-weight-normal color-text-regular')}
          >
            {label}
          </span>
        </div>
        )}
        <ButtonBase
          id={id}
          onClick={onClick}
          className={clsx(isVariant ? styles.dropDownButtonVariant : styles.dropdownButton, 'body font-weight-normal color-text-regular', isVariant && 'width-full color-border-emphasis pad-l border')}
          reactlytics={{
            element,
          }}
          aria-expanded={isPopupOpened}
          ref={ref}
          tabIndex={0}
          aria-describedby={label || isVariant ? `${id}-label` : undefined}
        >
          {label ? travelers : currentValue}
          <IconChevronDown
            color="inherit"
            className={clsx(styles.dropdownIcon, 'color-graphic-regular')}
            isFilled={true}
            size="sm"
          />
        </ButtonBase>
      </>
    );
  }
);

DropdownButton.displayName = 'DropdownButton';

DropdownButton.propTypes = {
  id: PropTypes.string,
  element: PropTypes.string,
  label: PropTypes.string,
  currentValue: PropTypes.string,
  travelers: PropTypes.number,
  onClick: PropTypes.func,
  isPopupOpened: PropTypes.bool.isRequired,
};

DropdownButton.defaultProps = {
  id: '',
  element: '',
  label: '',
  currentValue: '',
  travelers: '',
  onClick: null,
};

export default DropdownButton;
